import React from "react";
import Header from "./Header";
import {TrophyIcon} from "../icons/TrophyIcon";
import PoweredBy from "./PoweredBy";

function UploadSuccess({message}) {
    return (
        <div className="flex flex-col w-full h-full">
            <Header closeEnabled={false}/>
            <div className="flex flex-col p-4 w-full h-full justify-between">
                <div className="flex flex-col items-center mt-20 gap-20">
                    <TrophyIcon/>
                    <div className="font-bold text-2xl gradient-text">{message}</div>
                </div>
                <div className="flex flex-row justify-center">
                    <PoweredBy/>
                </div>
            </div>
        </div>

    );
}

export default UploadSuccess;
